const v1 = 'v1';
const v2 = 'v2';

export const apiUrls = {
  login: {
    telegramConnect: `/${v1}/authz/telegram/connect`,
    refreshToken: `/${v1}/authz/refresh-token`
  },
  profile: {
    init: `/${v1}/init`,
    get: `/${v1}/profile`,
    delete: `/${v1}/profile`,
    update: `/${v1}/profile`,
    recover: `/${v1}/profile/recover`,
    hide: `/${v1}/profile/hide`,
    show: `/${v1}/profile/show`,
    shadow: `/${v1}/profile/shadow`,
    unshadow: `/${v1}/profile/unshadow`,
    markOnline: `/${v1}/profile/mark-online`,
    preparePhoto: `/${v2}/profile/photos/prepare`,
    prepareSelfie: `/${v2}/profile/photos/selfie/prepare`,
    channelPolicy: `/${v1}/profile/notifications/telegram-bot/policy`,
    updateLocale: `/${v1}/profile/settings/locale`,
    deletePhoto: (hid: string) => `/${v2}/profile/photos/${hid}`,
    submitPhotoToReview: `/${v2}/profile/photos/submit-to-review`,
    updateSearchFilters: `/${v1}/profile/settings/search-filter`,
    updateCoordinates: `/${v1}/profile/settings/coordinates`,
    updatePrivacy: `/${v1}/profile/settings/privacy`,
    prepareVideo: `/${v2}/profile/videos/prepare`,
    deleteVideo: (hid: string) => `/${v2}/profile/videos/${hid}`,
    completePhoto: (hid: string) => `/${v2}/profile/photos/${hid}/complete`,
    completeVideo: (hid: string) => `/${v2}/profile/videos/${hid}/complete`
  },
  matchmaker: {
    users: (limit: number) => `/${v1}/matchcraft/users/${limit}`,
    like: (hid: string) => `/${v1}/matchcraft/users/${hid}/like`,
    pass: (hid: string) => `/${v1}/matchcraft/users/${hid}/pass`
  },
  relation: {
    likesMe: `/${v1}/relation/contacts/likes-me`,
    sentLikes: `/${v1}/relation/contacts/likes-sent`,
    getContact: (hid: string) => `/${v1}/relation/contact/${hid}`,
    summaries: `/${v1}/relation/summaries`,
    blockUser: (hid: string) => `/${v1}/relation/contact/${hid}/block`
  },
  messaging: {
    listDialogs: `/${v1}/messaging/dialogs`,
    deleteDialog: (id: string) => `/${v1}/messaging/dialogs/${id}`,
    createTextMessage: (id: string) => `/${v1}/messaging/messages/${id}/text`,
    getDialogMessages: (id: string) => `/${v1}/messaging/messages/${id}`,
    readMessages: (id: string) => `/${v1}/messaging/messages/${id}/read-all`,
    sendGift: (id: string) => `/${v1}/messaging/messages/${id}/gift`,
    acceptGift: (id: string) => `/${v1}/messaging/messages/${id}/gift/accept`,
    declineGift: (id: string) => `/${v1}/messaging/messages/${id}/gift/decline`
  },

  purchases: {
    createInvoice: `/${v1}/billing/telegram/invoice`,
    getSubscription: `/${v1}/billing/subscription/purchases`
  },
  ton: {
    challenges: `/${v1}/ton/challenges`,
    balance: `/${v1}/ton/balance`,
    transactions: `/${v1}/ton/transactions`,
    payout: `/${v1}/ton/payout`,
    claimReward: (id: string) => `/${v1}/ton/challenges/${id}/claim-reward`
  }
};
